export const shouldKeepFormState = ({ state, pathname }, prevRoute) => {
    if (state) {
        return !state.shouldLoadForm;
    }
    const path = prevRoute?.location?.pathname || prevRoute?.pathname;
    if (!path.includes(pathname)) {
        return false;
    }
    return false;
};

export default { shouldKeepFormState };
